import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from '../../Common/CommonHooks';
import AddSlipBtn from '../Common/AddSlipBtn';
import OddsTable, { clipboardMeetingRow } from '../Common/RCOddsTableCompact';
import OddsDropLegend from '../Common/OddsDropLegend';
import InvestmentCalculator from '../Common/InvestmentCalculator';
import Investment from '../Common/Investment';
import { getComingleMsgs, getMaxRunnerSize, getIsShowPmuText } from '../Common/Common';
import { isLocalMeeting } from '../../Common/home-common';
import ComingleMsg from '../Common/ComingleMsg';
import MultiLegSlider from '../Common/MultiLegSlider';
import IWNOddsTable from '../Common/IWNOddsTable';
import { RacingContext } from '../../Home/RacingPage';
import { MobileCurrentOdds } from '../Common/CurrentOdds';
import Loading from '../../Common/ui-components/Loading';
import { isStartSellpmPool } from '../Common/Common';
import ClearAllHorseSelectionsButton from '../Common/ClearAllHorseSelectionsButton';

const OddsDBL = (props) => {
    const { t, i18n} = useTranslation();
    const { isMobileSize } = useWindowSize();
    const context = useContext(RacingContext);

    const RCColumns = {
        no: true,
        banker1: false,
        banker2: false,
        banker3: false,
        leg: true,
        horseName: true,
        rcNoteM: false,
        win: true,
        place: false,
        field: true,
        banker1F: false,
        banker2F: false,
        banker3F: false
    }

    const RCColumnLbls = {
        leg: t('LB_RC_ODDS_SEL')
    }

    if (context == null) {
        return <Loading/>
    } else {
        const mtg = context.content.meeting;
        let pool =  mtg.pmPools.filter((data) => data.leg.races[0] == context.content.raceNo && ["DBLPre", "DBL"].includes(data.oddsType))[0];
        if ( pool==null )
            return null;

        let legList = pool.leg.races;

        const defTableSize = Math.max(14, getMaxRunnerSize(context, legList, 0, 3));
        let isStartSell = isStartSellpmPool(pool);//pool.status==="START_SELL";

        let tmpMsgs = getComingleMsgs(mtg, context.content.page, context.content.raceNo);
        const isShowPmu = getIsShowPmuText(mtg, legList)
        let comingleMsg1 = [];
        let comingleMsg2 = [];
        let noteCnt = 1;
        if (tmpMsgs != null) {
            let comingleLang = i18n.language == "en" ? "E" : "C";
            if (tmpMsgs['NOTE1_' + comingleLang] != '')
                comingleMsg1.push(<div className="rc-comingle-remarks"><span style={{ fontWeight: "bold" }}>{t('LB_RC_COMINGLE_NOTE')}{noteCnt++}: </span>{tmpMsgs['NOTE1_' + comingleLang]}</div>);
            if (tmpMsgs['NOTE2_' + comingleLang] != '')
                comingleMsg1.push(<div className="rc-comingle-remarks"><span style={{ fontWeight: "bold" }}>{t('LB_RC_COMINGLE_NOTE')}{noteCnt++}: </span>{tmpMsgs['NOTE2_' + comingleLang]}</div>);
            if (tmpMsgs['NOTE3_' + comingleLang] != '')
                comingleMsg2.push(<div className="rc-comingle-remarks"><span style={{ fontWeight: "bold" }}>{t('LB_RC_COMINGLE_NOTE')}{noteCnt++}: </span>{tmpMsgs['NOTE3_' + comingleLang]}</div>);
        }

        context.racingFuncs.copyClipboardRightOddsTable = () => {
            return `<table><tr>
                ${legList.map((_cItem, _cIndex) => {
                    return `<td>${clipboardMeetingRow({ context, t, i18n, raceNo: _cItem, columns: RCColumns, showRaceHeader: true })}</td><td></td>`
                }).join("")}
            </tr></table>`;
        }

        return (
            <section className={context.content.page}>
                <Investment betType={context.content.page} />
                <InvestmentCalculator  className='border-radius-down' enable={!context.windowSize.isMobileSize} />
                {!context.windowSize.isMobileSize && <MobileCurrentOdds />}
                <div className={isLocalMeeting(context.content.venue) ? "marginTop12": "dblTableTop"}><IWNOddsTable enableQuickBet={!isMobileSize && isStartSell} isStartSell={isStartSell} msg={''} legList={legList}/></div>
                {
                    isMobileSize ? <MultiLegSlider cnt={legList.length} className="multi-leg-2x-table">
                        {legList.map((_cItem, _cIndex) => {
                            return <OddsTable betType={context.content.page} columns={RCColumns} lbl={RCColumnLbls}
                                firstRace={legList[0]} raceNo={_cItem} startCnt={1}
                                selectedBetType={context.content.page} showRaceHeader="true" defTableSize={defTableSize} key={_cItem}/>
                        })}
                    </MultiLegSlider> :
                    <table style={{  display:'block' }}>
                        <tr className="multi-leg-2x-table">
                            {
                                legList.map((_cItem, _cIndex) => {
                                    return <td style={{ display:'flex', flexDirection: 'column' }}><OddsTable betType={context.content.page} columns={RCColumns} lbl={RCColumnLbls}
                                        firstRace={legList[0]} raceNo={_cItem} startCnt={1}
                                        selectedBetType={context.content.page} showRaceHeader="true" defTableSize={defTableSize} key={_cItem}/></td>
                                })
                            }
                        </tr>
                    </table>

                }
                {/* {comingleMsg1} */}

                {!isLocalMeeting(context.content.venue) ? <div className="dblTableBtm"><IWNOddsTable enableQuickBet={!isMobileSize && isStartSell} isStartSell={isStartSell} msg={''} legList={legList}/></div> : null}
                {isShowPmu && <div className="merge-comingle-remarks" style={{ paddingBottom: '4px' }}><ComingleMsg></ComingleMsg></div>}
                <OddsDropLegend />
                <div className="multi-leg-footer-betSlip">
                    <div>
                        {window.globalConfig.enableHRClearAllSelectionButton && !context.windowSize.isMobileSize && (
                            <ClearAllHorseSelectionsButton />
                        )}
                        <AddSlipBtn />
                    </div>
                </div>
                {context.windowSize.isMobileSize && <MobileCurrentOdds />}
                <InvestmentCalculator  className={context.windowSize.isMobileSize ? 'investment-calculator-drop-shadow border-radius-all' : 'border-radius-down'} enable={true} />
            </section>
        );
    }
}
export default OddsDBL;